import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Link, Grid, Typography, ListItem, List } from "@material-ui/core"
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import duas from "../images/icon/duas.png"
import quran from "../images/icon/quran.png"
import TodayIcon from '@material-ui/icons/Today';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import Routes from "../Constants/Routes"
import playStoreImage from "../images/playstore.png"
import { Translate } from 'react-redux-i18n';
import AlifAppImage from "../images/AlifApp.png"
import menulist from '../Constants/MenuList';
import route from '../Constants/Routes';
const useStyles = makeStyles((theme) => ({

  appBar: {
    top: 'auto',
    bottom: 1,
    background: "whitesmoke"
  },
  imgTop: {
    // top:"-7px"
    marginTop: "-2px"
  },
  image: {
    zIndex: 0
  },
  white: {
    color: "white"
  }
}));

export default function BottomAppBar(props) {
  const classes = useStyles();
  let { language  } = props
  
  
  return (
    <React.Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <div className="playstoretitle">
            <div className="paddingtop">
            {
               language ==="English" || language == ""?
               "STAY ON TOP OF YOUR ISLAM"
               :
               "உங்கள் இஸ்லாத்தின் மேல் இருங்கள்"
            }
              
            </div>
            <div className="paddingtop">
              {
                language ==="English" || language == ""?
                "Download Alif Islamic Learning App"
                :
                "அலிஃப் இஸ்லாமிய கற்றல் பயன்பாட்டைப் பதிவிறக்கவும்"
              } 
          </div>
            <div className="paddingtop">
              <a href= {language === "English" || language == "" || language == undefined ?"https://play.google.com/store/apps/details?id=islam.zain.alif":"https://play.google.com/store/apps/details?id=com.islam.aliftamil"}>
                <img src={playStoreImage} alt="Alif Islamic App Link" />
              </a>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div style={{ 'marginTop': "70px" }}></div>
          <div className="alifappscreenshot">
            <img src={AlifAppImage} alt="Alif Islamic learning App Screenshot" className="img-fluid" width="100%" />
          </div>
        </Grid>

      </Grid>
      <Grid container spacing={1}>
        <Grid xs={6} sm={3}>
          <List>
            <ListItem>
              <a className={classes.white} href={`${language}`} >
                <Translate value="home.home" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.quran}/${language}`}>
                <Translate value="home.quran" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.duas}/${language}`}>
                <Translate value="home.duas" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.names}/${language}`}>
                <Translate value="home.nameOfAllah" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.basicquran}/${language}`}>
                <Translate value="home.basicquran" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.islamicgallery}/${language}`}>
                <Translate value="home.islamicgallery" />
              </a>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={6} sm={3}>
          <List>
            <ListItem>
              <a className={classes.white} href={`${route.route.kursi}/${language}`}>
                <Translate value="home.kursi" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.hadith}/${language}`}>
                <Translate value="home.hadith" />
              </a>
            </ListItem>
            <ListItem>
              <a className={classes.white} href={`${route.route.kalima}/${language}`}>
                <Translate value="home.kalima" />
              </a>
            </ListItem>
          </List>
          <a href={`/privacypolicy/${language}`} className={classes.white}>
            Privacy Policy
              </a>
        </Grid>
      </Grid>
    
    </React.Fragment>
  );
}
